/**
 * Retrieves the current season: 1) summer, 2) winter, 3) fall or 4) spring
 *
 * Winter:  22 Dec - 21 Mar
 * Spring:  22 Mar - 21 Jun
 * Summer:  22 Jun - 21 Sep
 * Fall:    22 Sep - 21 Dec
 */
export function getCurrentSeason() {
    // It's plus one because January is index 0
    const now = new Date();
    const month = now.getMonth() + 1;

    if (month > 3 && month < 6) {
        return 'spring';
    }

    if (month > 6 && month < 9) {
        return 'summer';
    }

    if (month > 9 && month < 12) {
        return 'fall';
    }

    if (month >= 1 && month < 3) {
        return 'winter';
    }

    const day = now.getDate();
    if (month === 3) {
        return day < 22 ? 'winter' : 'spring';
    }

    if (month === 6) {
        return day < 22 ? 'spring' : 'summer';
    }

    if (month === 9) {
        return day < 22 ? 'summer' : 'fall';
    }

    if (month === 12) {
        return day < 22 ? 'fall' : 'winter';
    }

    console.error('Unable to calculate current season');
}
